import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getHost, populatePost, withoutMapSelection } from "./utils";
import { searchHotelOffers } from "./hotelSlice";
import { isArray } from "lodash";

axios.defaults.headers.common["AgencyID"] = window.configData.AGENCYID;
axios.defaults.headers.common["Version"] = import.meta.env.VITE_APP_VERSION;
axios.defaults.headers.common["App"] = window.configData.APP;

export const getDepartures = createAsyncThunk("filter/getDepartures", async (payload, thunkAPI) => {
  //let state = thunkAPI.getState();

  try {
    const response = await axios.get(getHost() + "/checkairports?zipcode=" + encodeURIComponent(payload.zipcode) + "&info=airports");

    return response.data;
  } catch (error) {
    console.log(error);
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

export const getAllActions = createAsyncThunk("filter/getAllActions", async (payload, thunkAPI) => {
  //let state = thunkAPI.getState();
  //console.log(payload);

  try {
    const response = await axios.get(getHost() + "/getallactions?agencyid=" + window.configData.AGENCYID);

    return response.data;
  } catch (error) {
    console.log(error);
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

export const setSessionOptions = createAsyncThunk("filter/setsessionoptions", async (payload, thunkAPI) => {
  let state = thunkAPI.getState();
  //console.log(payload);
  //console.log({ ...payload, sessionid: state.system.sessionId });
  try {
    const response = await axios.post(
      getHost() + "/setsessionoptions",

      { ...payload, sessionid: state.system.sessionId },
    );

    return response.data;
  } catch (error) {
    console.log(error);
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

export const getSuggestions = createAsyncThunk("filter/getSuggestions", async (payload, thunkAPI) => {
  let state = thunkAPI.getState();
  //console.log(payload);
  let req = {};
  try {
    req = {
      ...populatePost(payload.hotel ? [state.hotel.selectedHotel] : [...state.search.selectedDestination], { ...(payload.hotel ? withoutMapSelection(state.search) : state.search), ...payload.update }, state.properties.departureStations),
    };
  } catch (e) {
    console.log(e);
    req = {};
  }
  try {
    const response = await axios.post(getHost() + "/getholidaysuggestions", {
      request: req,
      text: payload.text,
      zipcode: payload.zipcode,
      agencyid: window.configData.AGENCYID,
      sessionid: state.system.sessionid,
    });

    return response.data;
  } catch (error) {
    console.log(error);
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

export const propertiesCheck = createAsyncThunk("filter/filteredProperties", async (payload, thunkAPI) => {
  let state = thunkAPI.getState();

  let parms = {
    ...populatePost(payload.hotel ? [state.hotel.selectedHotel] : [...state.search.selectedDestination], { ...(payload.hotel ? withoutMapSelection(state.search) : state.search), ...payload.update }, state.properties.departureStations),

    property: payload.property,
  };

  try {
    const response = await axios.post(getHost() + "/inventoryDataForPackageCheck", parms);
    //console.log(response.data);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

export const filteredProperties = createAsyncThunk("filter/filteredProperties", async (payload, thunkAPI) => {
  let state = thunkAPI.getState();

  let giataids = [];
  if (payload.property === "TourOperatorsForHotel") {
    if (Array.isArray(state?.offers?.offerInfos?.HotelDictionary?.Hotel)) {
      /*console.log(
          "TourOperatorsForHotel",
          Array.isArray(state?.offers?.offerInfos?.HotelDictionary?.Hotel)
        );*/
      //console.log("touroperatorsForHotel");

      let ct = 0;
      let iffs = state.filter.touroperatorsForHotel.map((e) => e.HotelIffCode);
      //console.log(iffs);
      for (let i = 0; i < state.offers.offerInfos.HotelDictionary.Hotel.length; i++) {
        if (ct >= 500) {
          //console.log(state.offers.offerInfos.HotelDictionary.Hotel[i]);

          break;
        }
        let hotel = state.offers.offerInfos.HotelDictionary.Hotel[i];
        if (!iffs.includes(hotel.HotelCodes.HotelIffCode)) {
          ct = ct + 1;
          giataids.push(hotel.HotelCodes.HotelGiataID);
        }
      }
    }
  }

  let parms = {
    ...populatePost(payload.hotel ? [state.hotel.selectedHotel] : [...state.search.selectedDestination], { ...(payload.hotel ? withoutMapSelection(state.search) : state.search), ...payload.update }, state.properties.departureStations),

    property: payload.property,
  };

  // Filterlisten: pro-Zimmer gewaehlte types/boardTypes aus roomallocation strippen
  // (Belegung bleibt erhalten) - sonst schraenkt sich die jeweilige Liste auf die
  // bereits gewaehlten Werte ein.
  if (parms.roomallocation) {
    try {
      parms.roomallocation = JSON.stringify(JSON.parse(parms.roomallocation).map((r) => ({ adults: r.adults, childrenAges: r.childrenAges })));
    } catch {
      /* unbrauchbar -> unveraendert */
    }
  }

  if (payload.property === "TourOperatorsForHotel") {
    if (giataids.length === 0) {
      return {};
    }
    parms = {
      ...populatePost(payload.hotel ? [state.hotel.selectedHotel] : [...state.search.selectedDestination], { ...(payload.hotel ? withoutMapSelection(state.search) : state.search), ...payload.update }, state.properties.departureStations),
      HotelGiataID: giataids,
      property: payload.property,
    };
  }
  try {
    const response = await axios.post(getHost() + (state?.search?.activeMode == "ACC" ? "/inventoryDataForAccommodationFiltered" : "/inventoryDataForPackageFiltered"), parms);
    //console.log(response.data);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

const initialState = {
  filterqueryid: "",
  boardTypes: [],
  roomTypes: [],
  regionGroups: [],
  roomViews: [],
  cabinClasses: [],
  tourOperators: [],
  touroperatorsForHotel: [],
  hotelAttributes: [],
  hotelCount: 0,
  allActions: [],
  destinationAirports: [],
  marketingActions: [],
  originalDestination: [],
  hotelMarketingActions: [],
  optionOperators: [],
  giataoperators: [],
  filterRegion: "-",
  transportOperators: [],
  holidaySuggestions: [],
  selectedRoomAttributes: [],
  roomAttributesFilter: {},
  departures: [],
  sessionOptions: {},
  appliedSearchfilters: {},
  offerlistfilter: "",
};

export const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    setOfferlistfilter: (state, action) => {
      state.offerlistfilter = action.payload;
    },
    setFilterqueryid: (state, action) => {
      state.filterqueryid = action.payload;
    },
    setFilterRegion: (state, action) => {
      state.filterRegion = action.payload;
    },

    setOriginalDestination: (state, action) => {
      state.originalDestination = action.payload;
    },

    setGiataoperators: (state, action) => {
      state.giataoperators = action.payload;
    },

    setAppliedSearchfilters: (state, action) => {
      let applied = action.payload ? action.payload : {};
      if (Array.isArray(action.payload)) {
        if (action.payload.length > 0) applied = action.payload[0];
        else applied = {};
      }
      state.appliedSearchfilters = applied;
    },

    setOptionOperators: (state, action) => {
      state.optionOperators = action.payload;
    },

    setTouroperatorsForHotel: (state, action) => {
      state.touroperatorsForHotel = action.payload;
    },

    setSelectedRoomAttributes: (state, action) => {
      state.selectedRoomAttributes = action.payload;
    },

    setRoomAttributesFilter: (state, action) => {
      state.roomAttributesFilter = action.payload;
    },

    setHotelCount: (state, action) => {
      state.hotelCount = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(setSessionOptions.fulfilled, (state, action) => {
      state.sessionOptions = action.payload;
    });

    builder.addCase(getSuggestions.fulfilled, (state, action) => {
      state.holidaySuggestions = action.payload.ret;
    });

    builder.addCase(getDepartures.fulfilled, (state, action) => {
      state.departures = action.payload.ret;
    });

    builder.addCase(filteredProperties.pending, () => {
      //state.hotelOfferInfos = {};
    });

    builder.addCase(getAllActions.fulfilled, (state, action) => {
      state.allActions = action.payload.ret;
    });

    builder.addCase(filteredProperties.fulfilled, (state, action) => {
      //console.log(action.payload);

      if (action.payload.RS_Metadata && action.payload.RS_Metadata.TransactionID != state.filterqueryid) return;
      if (action.meta.arg.property === "TouristicRegions" && Array.isArray(action.payload.RegionGroups?.RegionGroup)) {
        let ct = 0;
        for (let i = 0; i < action.payload.RegionGroups.RegionGroup.length; i++) {
          ct += action.payload.RegionGroups.RegionGroup[i].HotelCount;
        }

        if (action.meta.arg.touristicRegions) {
          state.regionGroups = action.payload.RegionGroups?.RegionGroup;
          state.filterRegion = "-";
        }
        state.hotelCount = ct;
      }

      if (action.meta.arg.property === "RoomType" && action.payload.RoomTypes?.RoomType) state.roomTypes = action.payload.RoomTypes.RoomType;
      if (action.meta.arg.property === "BoardTypes" && action.payload.BoardTypes?.BoardType) state.boardTypes = action.payload.BoardTypes.BoardType;
      if (action.meta.arg.property === "RoomView" && action.payload.RoomViews?.RoomView) state.roomViews = action.payload.RoomViews.RoomView;
      if (action.meta.arg.property === "DestinationStations" && action.payload.Stations?.DestinationStations) {
        //console.log("DestinationStations.DestinationStation",action.payload.Stations?.DestinationStations);
        state.destinationAirports = action.payload.Stations?.DestinationStations;
      }
      if (action.meta.arg.property === "TourOperatorsForHotel" && action.payload.TourOperatorsForHotels && Array.isArray(action?.payload?.TourOperatorsForHotels?.TourOperatorsForHotel)) {
        if (action.meta.arg.firstcall) {
          state.touroperatorsForHotel = action.payload.TourOperatorsForHotels.TourOperatorsForHotel;
        } else {
          state.touroperatorsForHotel = [...state.touroperatorsForHotel, ...action.payload.TourOperatorsForHotels.TourOperatorsForHotel];
        }
      }

      if (Array.isArray(action?.payload?.TransportOperatingBrands?.TransportOperatingBrand)) {
        let oplines = [];
        /*console.log(
          "TransportOperatingBrand",
          action.payload.TransportOperatingBrands.TransportOperatingBrand.length
        );*/
        for (let i = 0; i < action.payload.TransportOperatingBrands.TransportOperatingBrand.length; i++) {
          oplines.push({
            value: action.payload.TransportOperatingBrands.TransportOperatingBrand[i].Code,
            label: action.payload.TransportOperatingBrands.TransportOperatingBrand[i].Name,
          });
        }
        state.transportOperators = oplines;
      }

      if (action.meta.arg.property === "TourOperator" && action.payload.TourOperators?.TourOperator) state.tourOperators = action.payload.TourOperators.TourOperator;
      if (action.meta.arg.property === "HotelAttributes" && action.payload.HotelAttributes?.HotelAttribute) state.hotelAttributes = action.payload.HotelAttributes.HotelAttribute;
    });
    builder.addCase(filteredProperties.rejected, () => {
      //console.log(action);
      //state.hotelOfferInfos = {};
    });

    builder.addCase(searchHotelOffers.fulfilled, (state, { payload, meta }) => {
      if (payload.Offers.OfferCount > 0) {
        let infos = { ...payload };

        let maArray = meta.arg.offset === 0 ? [] : [...state.hotelMarketingActions];
        //console.log(maArray)
        for (let i = 0; i < infos.Offers.Offer.length; i++) {
          let off = infos.Offers.Offer[i];
          if (Array.isArray(off?.MarketingActions)) {
            for (let j = 0; j < off.MarketingActions.length; j++) {
              let ma = off.MarketingActions[j];

              if (ma.typ_id === "0018-0001" || ma.typ_id === "0018-0002") {
                //console.log("LAB: " + ma.MarketingProperties.label);
                if (!maArray.find((e) => e.label === ma.MarketingProperties.label)) {
                  maArray.push({
                    label: ma.MarketingProperties.label,
                    typ_id: ma.typ_id,
                    count: 1,
                  });
                } else {
                  let tmpAction = maArray.find((e) => e.label === ma.MarketingProperties.label);
                  tmpAction.count += 1;
                }
              }
            }
          }
        }
        state.hotelMarketingActions = [...maArray];
      }
    });
  },
});

export const {
  setOptionOperators,
  setTouroperatorsForHotel,
  setOfferlistfilter,
  setSelectedRoomAttributes,
  setRoomAttributesFilter,
  setFilterqueryid,
  setFilterRegion,
  setGiataoperators,
  setAppliedSearchfilters,
  setOriginalDestination,
  setHotelCount,
} = filterSlice.actions;

export default filterSlice.reducer;
